import { Divider, Heading, Stack, StackProps } from "@chakra-ui/react";

export interface CollapseCardItemProperties extends Omit<StackProps, "title"> {
  hasDelimiters?: boolean;
  title?: React.ReactNode;
}

export const CollapseCardItem = ({
  children,
  direction = "column",
  hasDelimiters = true,
  title,
  ...rest
}: CollapseCardItemProperties): React.ReactElement => {
  const content = (
    <Stack alignItems="start" direction={direction} {...rest}>
      <Heading color="gray.500" fontWeight="semibold" size="sm">
        {title}
      </Heading>
      {children}
    </Stack>
  );

  return hasDelimiters ? (
    <Stack data-testid="CollapseCardItem - divider" mt={2}>
      <Divider />
      {content}
    </Stack>
  ) : (
    content
  );
};
